var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 6.45399V15.5473C18.3333 16.9406 18.205 17.9307 17.875 18.6365C17.875 18.6457 17.8658 18.664 17.8566 18.6732C17.655 18.9298 17.3892 19.0582 17.0775 19.0582C16.5917 19.0582 16.005 18.7373 15.3725 18.059C14.6209 17.2523 13.4658 17.3165 12.8058 18.1965L11.88 19.4248C11.5134 19.9198 11.0275 20.1673 10.5417 20.1673C10.0558 20.1673 9.56998 19.9198 9.20331 19.4248L8.26835 18.1873C7.61752 17.3165 6.47166 17.2523 5.71999 18.0498L5.71082 18.059C4.67498 19.1682 3.75835 19.3332 3.22668 18.6732C3.21752 18.664 3.20833 18.6457 3.20833 18.6365C2.87833 17.9307 2.75 16.9406 2.75 15.5473V6.45399C2.75 5.06065 2.87833 4.07065 3.20833 3.36482C3.20833 3.35565 3.20835 3.34648 3.22668 3.33732C3.74918 2.66815 4.67498 2.83315 5.71082 3.94232L5.71999 3.95149C6.47166 4.74899 7.61752 4.68482 8.26835 3.81398L9.20331 2.57649C9.56998 2.08149 10.0558 1.83398 10.5417 1.83398C11.0275 1.83398 11.5134 2.08149 11.88 2.57649L12.8058 3.80482C13.4658 4.68482 14.6209 4.74898 15.3725 3.94232C16.005 3.26398 16.5917 2.94315 17.0775 2.94315C17.3892 2.94315 17.655 3.08065 17.8566 3.33732C17.875 3.34648 17.875 3.35565 17.875 3.36482C18.205 4.07065 18.3333 5.06065 18.3333 6.45399Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 9.39648H14.6668",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 12.6035H12.8335",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteHistory);
export default __webpack_public_path__ + "static/media/delete-history.b157ae1698afbbd078ae25f1f63e2b46.svg";
export { ForwardRef as ReactComponent };